import { RoleTypes } from 'firebaseFunctions/types'

export const roleDescriptions = {
  [RoleTypes.Owner]: 'Administrator',
  [RoleTypes.Writer]: 'Can edit tasks',
  [RoleTypes.Reader]: 'Can only read tasks',
}
